if (!customElements.get('sticky-atc-bar-minimalist')) {
  customElements.define(
    'sticky-atc-bar-minimalist',
    class StickyAtcBarMinimalist extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isOpen: 'sticky-atc-bar--show',
        };

        this.submitEl.addEventListener('click', this.onClick.bind(this));
      }

      get submitEl() {
        return (this._submitEl = this._submitEl || this.querySelector('[type="submit"]'));
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');

        this.init();

        this.cartErrorUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, () => {
          this.resetButtonLoading();
          this.scrollToTop(this.productFormActions);
        });

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
          this.resetButtonLoading();
        });
      }

      disconnectedCallback() {
        document.body.classList.remove('sticky-atc-bar-minimalist-open');

        if (this.priceObserver) {
          this.priceObserver.disconnect();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      init() {
        if (!this.productFormActions) {
          this.classList.remove(this.classes.isOpen);
          return;
        }

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle(this.classes.isOpen, isAboveViewport);
              document.body.classList.toggle('sticky-atc-bar-minimalist-open', isAboveViewport);
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);
        this.mirrorMainProductPrice();
        this.syncWithMainProductForm();
      }

      // Sticky bar fiyatını ana ürün fiyatının (#price-<section>) AYNASI yap.
      // product-info varyant değişiminde bu DOM'u her zaman günceller (server-render,
      // b2b/guest/normal fiyatlar zaten doğru). Pubsub sırasına/varyant JSON'una bağlı değil.
      mirrorMainProductPrice() {
        const mainSectionId = this.mainProductInfo ? this.mainProductInfo.dataset.section : this.dataset.section;
        this.mainPriceEl = document.getElementById('price-' + mainSectionId);
        this.stickyPriceSlots = this.querySelectorAll('.sticky-atc-bar__mobile-price, .sticky-atc-bar__price-desktop');
        if (!this.mainPriceEl || !this.stickyPriceSlots.length) return;

        // Varyant görsel haritası (id -> url) ve ana form varyant input'u.
        let imageMap = null;
        try {
          const mapEl = this.querySelector('.sticky-variant-images');
          if (mapEl) imageMap = JSON.parse(mapEl.textContent);
        } catch (e) {}
        const variantInput = document.querySelector(
          'product-info [name="id"], #product-form-' + mainSectionId + ' [name="id"]'
        );
        const stickyImages = this.querySelectorAll(
          '.sticky-atc-bar__product-image img, .sticky-atc-bar__feature-image img'
        );

        const syncImage = () => {
          if (!imageMap || !variantInput) return;
          const url = imageMap[variantInput.value];
          if (!url) return;
          stickyImages.forEach((img) => {
            if (img.getAttribute('src') !== url) {
              img.setAttribute('src', url);
              img.removeAttribute('srcset');
            }
          });
        };

        const sync = () => {
          const html = this.mainPriceEl.innerHTML;
          this.stickyPriceSlots.forEach((slot) => {
            if (slot.innerHTML !== html) slot.innerHTML = html;
          });
          syncImage();
        };
        sync();
        this.priceObserver = new MutationObserver(sync);
        this.priceObserver.observe(this.mainPriceEl, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      onClick() {
        this.submitEl.setAttribute('aria-disabled', 'true');
        this.submitEl.classList.add('btn--loading');
      }

      resetButtonLoading() {
        this.submitEl.removeAttribute('aria-disabled');
        this.submitEl.classList.remove('btn--loading');
      }

      scrollToTop(target, offset = 200) {
        const scrollIntoView = (selector, offset) => {
          window.scrollTo({
            behavior: 'smooth',
            top: selector.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
          });
        };

        scrollIntoView(target, offset);
      }

      updateButton(disable = true, text, modifyClass = true) {
        const addButton = this.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCartShort;
        }
      }

      updatePrice(variant) {
        if (!variant) return;
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const fmt = (v) => FoxTheme.Currency.formatMoney(v, moneyFormat);

        // Adell Pro Partners (B2B): bar'daki TÜM b2b fiyat bloklarını (mobil + masaüstü) varyantla senkronla
        const b2bWraps = this.querySelectorAll('.f-price--b2b-pro');
        if (b2bWraps.length) {
          const { compare_at_price: b2bWas, price: b2bNow } = variant;
          b2bWraps.forEach((b2bWrap) => {
            const wasEl = b2bWrap.querySelector('.f-price__b2b-was');
            const nowEl = b2bWrap.querySelector('.f-price__b2b-now');
            const saveEl = b2bWrap.querySelector('.f-price__b2b-save');
            if (nowEl) nowEl.innerHTML = fmt(b2bNow);
            if (b2bWas && b2bWas > b2bNow) {
              if (wasEl) {
                wasEl.innerHTML = fmt(b2bWas);
                wasEl.style.display = '';
              }
              if (saveEl) {
                const pct = Math.round(((b2bWas - b2bNow) * 100) / b2bWas);
                saveEl.innerHTML = `<svg viewBox="0 0 12 12" width="11" height="11" aria-hidden="true"><path d="M6 9.2 1.8 4h8.4z" fill="currentColor"/></svg>%${pct} <span class="f-price__b2b-plan-inline">(Peşin)</span>`;
                saveEl.style.display = '';
              }
            } else {
              if (wasEl) wasEl.style.display = 'none';
              if (saveEl) saveEl.style.display = 'none';
            }
          });
          return;
        }

        // Normal/guest: price.liquid'deki b2b korumasıyla aynı —
        // compareAt > price ise ziyaretçiye fiyat = compareAt, çizik gösterme.
        let { compare_at_price, price, unit_price_measurement } = variant;
        if (compare_at_price && compare_at_price > price) {
          price = compare_at_price;
          compare_at_price = 0;
        }

        this.querySelectorAll('.f-price').forEach((priceWrapper) => {
          priceWrapper.classList.remove('f-price--on-sale');
          priceWrapper.classList.toggle('f-price--sold-out', !variant.available);

          const salePrice = priceWrapper.querySelector('.f-price-item--sale');
          if (salePrice) salePrice.innerHTML = fmt(price);
          priceWrapper.querySelectorAll('.f-price-item--regular').forEach((item) => {
            item.innerHTML = fmt(price);
          });

          const unitPriceWrapper = priceWrapper.querySelector('.f-price__unit-wrapper');
          if (!unitPriceWrapper) return;
          const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');
          if (unit_price_measurement && unitPrice) {
            unitPriceWrapper.classList.remove('hidden');
            const refValue = unit_price_measurement.reference_value !== 1 ? unit_price_measurement.reference_value : '';
            unitPrice.innerHTML = `<span>${fmt(variant.unit_price)}</span>/<span data-unit-price-base-unit>${refValue}${unit_price_measurement.reference_unit || ''}</span>`;
          } else {
            unitPriceWrapper.classList.add('hidden');
          }
        });
      }

      syncWithMainProductForm() {
        // Fiyat mirrorMainProductPrice() ile senkronlanıyor; burada sadece buton durumu.
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const mainSectionId = this.mainProductInfo ? this.mainProductInfo.dataset.section : this.dataset.section;
          if (event.data.sectionId !== mainSectionId) return;
          const variant = event.data.variant;
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
